import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const ROIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="RO" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#FBCD17"
        fillRule="evenodd"
        d="M5 0h6v12H5V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#E11C1B"
        fillRule="evenodd"
        d="M11 0h5v12h-5V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#2E42A5"
        fillRule="evenodd"
        d="M0 0h5v12H0V0Z"
        clipRule="evenodd"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
